import { render, staticRenderFns } from "./CompareDepartmentCompareRow.vue?vue&type=template&id=7c65afd1&"
import script from "./CompareDepartmentCompareRow.vue?vue&type=script&lang=js&"
export * from "./CompareDepartmentCompareRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports